module.exports = __webpack_public_path__ + "assets/img/num-04-ccdb26ef.png";